import { legacy_createStore as createStore } from 'redux'

// Load state from sessionStorage
const loadState = () => {
  try {
    const serializedState = sessionStorage.getItem('reduxState')
    return serializedState ? JSON.parse(serializedState) : undefined
  } catch (err) {
    console.error('Failed to load state from sessionStorage:', err)
    return undefined
  }
}

// Save state to sessionStorage
const saveState = (state) => {
  try {
    const serializedState = JSON.stringify({
      user: state.user, // Only persist the user state
    })
    sessionStorage.setItem('reduxState', serializedState)
  } catch (err) {
    console.error('Failed to save state to sessionStorage:', err)
  }
}

// Initial state
const initialState = {
  sidebarShow: true,
  asideShow: false,
  theme: 'dark',
  user: null, // Default user is null
}

// Reducer function
const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      return { ...state, ...rest }

    case 'SET_USER':
      return { ...state, user: rest.user } // Set user details

    case 'LOGOUT':
      sessionStorage.removeItem('reduxState') // Remove persisted user data
      return { ...state, user: null } // Reset user state

    default:
      return state
  }
}

// Load persisted state
const persistedState = loadState()

// Create store with persisted state
const store = createStore(changeState, persistedState)

// Subscribe to store changes to save user state only
store.subscribe(() => {
  saveState(store.getState())
})

export default store
